import React, { useState } from 'react';
import BunkerRegTabsHeader from './BunkerRegTabsHeader';
import { BunkerRegTabsEnum } from '../BunkeringUtils';
import FuelReceivedTankTable from './FuelReceivedTankTable';
import { useVesselStore } from 'src/context/VesselContext';
import { useBunkerContext } from 'src/context/BunkerContext';
import { BunkerReceived } from 'src/types/ViewModel/Bunkering/BunkerReceived';
import BunkerRegStatusContainer from './status/BunkerRegStatusContainer';
import { BunkerRegTabsWrapper, FuelReceivedWrapper } from '../Bunkering.styles';
import { deafultSortFuelTanks } from '../bunker-rob-page/RobUtils';

interface Props {
    updateBunkerReceivedPerTanks: (bunkerReceivedPerTanks: BunkerReceived[]) => void;
}

const BunkerRegTabsContainer: React.FC<Props> = ({ updateBunkerReceivedPerTanks }) => {
    const { vessel } = useVesselStore();
    const { bunkerings, selectedBunkering } = useBunkerContext();
    const [selectedBunkerRegTab, setSelectedBunkerRegTab] = useState<BunkerRegTabsEnum>(BunkerRegTabsEnum.status);

    return (
        <BunkerRegTabsWrapper>
            <div style={{ flex: '0 0 auto' }}>
                <BunkerRegTabsHeader selectedBunkerRegTab={selectedBunkerRegTab} setSelectedBunkerRegTab={setSelectedBunkerRegTab} />
            </div>
            {selectedBunkerRegTab === BunkerRegTabsEnum.fuelReceived && (
                <FuelReceivedWrapper>
                    <FuelReceivedTankTable
                        fuelTanks={deafultSortFuelTanks(vessel)}
                        bunkerings={bunkerings}
                        selectedBunkering={selectedBunkering}
                        updateBunkerReceivedPerTanks={updateBunkerReceivedPerTanks}
                    />
                </FuelReceivedWrapper>
            )}
            {selectedBunkerRegTab === BunkerRegTabsEnum.status && <BunkerRegStatusContainer />}
        </BunkerRegTabsWrapper>
    );
};

export default BunkerRegTabsContainer;
